<template>
<div>
  <OverlayLoading :loading="loading" />
  <v-dialog v-model="dialogRoleExpire" persistent max-width="950px">
    <v-card class="pl-5 pr-5  pt-3 pb-3">
      <v-card-title>
        <span class="ra-head-text-bold pa-1" style="color: black;">สิทธิ์หมดอายุ</span>
        <v-btn absolute right top icon x-small @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-row justify="center" align="center">
        <v-col cols="11" class="text-center ">
          <v-divider
          ></v-divider>
        </v-col>
      </v-row>
      <v-card-text>
        <v-row align="center">
          <v-col cols="6">
            <v-card height="300">
              <div class="pa-3 text-center" style="background-color: #EFF4FD;">
                <span class="" style="color: #3776E9;">ข้อมูลสิทธิ์การโอน</span>
              </div>
              <v-row class="pa-5">
                <v-col cols="10">
                  <span>ชื่อสิทธิ์ย่อย: {{subRole}}</span>
                </v-col>
                <v-col cols="10">
                  <span>สถานะ: {{status}} </span>
                  <!-- <span>สถานะ: {{ statusList.filter(e => e.status === status)[0].statusTH || '-' }}</span> -->
                </v-col>
                <v-col cols="10">
                  <span>รูปแบบการอนุมัติ: {{approveType}}</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card height="300">
              <div class="pa-3 text-center" style="background-color: #EFF4FD;">
                <span class="" style="color: #3776E9;">ระยะเวลาการโอนสิทธิ์</span>
              </div>
              <v-row class="pa-5">
                <v-col cols="10">
                  <span>วันที่โอนสิทธิ์: {{initDate(this.startTransferDate)}}</span>
                </v-col>
                <v-col cols="10">
                  <span>ระยะเวลาการรับสิทธิ์: {{initDate(this.startTransferDate)}} - {{initDate(this.endTransferDate)}} </span>
                </v-col>
                <v-col cols="10">
                  <span>ใกล้หมดอายุ : {{this.nearExpire}} วัน</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <div class="mt-4">
          <span class="ra-head-text-bold pa-1">ผู้ที่ถูกโอนสิทธิ์</span>
        </div>
        <v-row>
          <v-spacer/>
          <v-col cols="5" class="pt-0 d-flex flex-row align-center justify-end">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              outlined
              dense
              clearable
              class="mt-0"
              label="ค้นหา"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="px-0">
            <v-data-table
              :headers="headersPrimaryRole"
              :items="roleExpireData"
              :items-per-page="5"
              :search="search"
              class="border-table-employee text-no-wrap mt-1 elevation-0"
              item-key="no"
              :expanded.sync="expanded"
              hide-default-footer
              disable-sort
              :loading="loading"
              loading-text="Loading... Please wait"
            >
            <template v-slot:item="{ item, index }">
              <tr style="cursor: pointer;">
                <td>{{ index + 1 }}</td>
                <td>{{ item.nameTh }}</td>
                <td>{{ item.position }}</td>
                <td>{{ item.positionLevel }}</td>
                <td>{{ item.comapanyName }}</td>
              </tr>
            </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="ra-button1 mx-2" color="#1654C6" dark @click="closeDialog">
            <v-icon
              color="#3776E9 darken-2"
              class="pl-0"
              small
            >
              mdi-account-multiple
            </v-icon>
              <span>ต่ออายุสิทธิ์</span>
          </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// import { UpdateTitleOrgchart, FullLoading } from '@/components/index'
import
{
// hostImageUrlv3
} from '@/API/API'
import { EventBus } from '@/EventBus'
// import swal from 'sweetalert'
import OverlayLoading from '../../_template/OverlayLoading'
const moment = require('moment')

export default {
  name: 'dialog-create-approver',
  components: {
    // FullLoading,
    // UpdateTitleOrgchart
    OverlayLoading
  },
  data () {
    return {
      expanded: [],
      isLoading: false,
      loading: false,
      loadingUsers: true,
      dialogRoleExpire: false,
      selected: [],
      itemUser: [],
      total: -1,
      perPage: 15,
      page: 1,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      // approveRole: localStorage.manageapproveRole === 'Admin' ? 'Admin' : 'Leader',
      approveRole: 'Admin',
      search: '',
      searchEmpoyee: '',
      dataSearchEmployee: '',
      typeAction: '',
      subRole: '',
      status: '',
      approveType: '',
      startTransferDate: '',
      endTransferDate: '',
      nearExpire: '',
      roleExpireData: [
        {
          no: '1',
          primaryRole: 'test',
          position: 'Sale',
          positionLevel: 'Manager',
          company: 'INET',
          transferDate: 'Date',
          expireRole: 'Expire',
          comExpireRole: 'testExpire',
          status: 'approve',
          orgChartHeaderName: 'ขอนแก่น'

        },
        {
          no: '2',
          primaryRole: 'tes2',
          position: 'Sale',
          positionLevel: 'Manager',
          company: 'INET',
          transferDate: 'Date2',
          expireRole: 'Expire2',
          comExpireRole: 'testExpire2',
          status: 'pending',
          orgChartHeaderName: 'กรุงเทพ'
        }
      ],
      headersPrimaryRole: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        // { text: 'ศูนย์', value: 'orgChartHeaderName' },
        { text: 'ชื่อผู้รับสิทธิ์', value: 'nameTh' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'ระดับตำแหน่ง', value: 'positionLevel' },
        { text: 'บริษัท', value: 'comapanyName' }
        // { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      statusList: [
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' },
        { status: 'active', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'expire', statusTH: 'หมดอายุ', color: '#D1392B' },
        { status: 'inActive', statusTH: 'ยกเลิก', color: '#757575' }
      ]
    }
  },
  beforeDestroy () {
    EventBus.$off('dialogRoleExpire')
  },
  async mounted () {
    await EventBus.$on('dialogRoleExpire', this.openDialogRoleExpire)
  },
  watch: {
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    // this.getUser()
    // this.getRoleExpireDetail(this.propsEmpId)
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      this.setFilter(this.filterData)
    },
    changePage (value) {
      this.page = value
      this.setFilter(this.filterData)
    },
    onImgError () {
      this.failed_image = true
    },
    async openDialogRoleExpire (value, item, action, index, type) {
      await this.getRoleExpireDetail(value._id)
      this.loading = true
      this.dialogRoleExpire = true
      this.loading = false
    },
    closeDialog () {
      this.dialogRoleExpire = false
    },
    clearSearchEmployee () {
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    async getRoleExpireDetail (id) {
      this.loading = true
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/authenTransferById`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          authenId: '6188d3137467641a4d807e7b',
          search: '',
          position: [''],
          positionLevel: [''],
          limit: 15,
          page: 1
        }
      }).then((response) => {
        this.subRole = response.data.result[0].authenName
        this.status = this.statusList.filter(e => e.status === response.data.result[0].status)[0].statusTH
        this.approveType = response.data.result[0].conditions === 'all' ? 'อนุมัติทุกคน' : 'อนุมัติแค่คนใดคนหนึ่ง'
        this.startTransferDate = response.data.result[0].startDate
        this.endTransferDate = response.data.result[0].endDate
        this.nearExpire = response.data.result[0].statusExpire === true ? 'หมดอายุ' : response.data.result[0].expire
        this.headerListData = response.data.result[0]
        this.roleExpireData = response.data.result[0].transfer
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  /* color: #1654C6; */
  color: black;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.radio-border-click {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
}
.v-input--radio-group.v-input--radio-group--row .v-radio .radio-border-click {
  border-color: red;
}
/* .v-input--radio-group .v-input--radio-group--row .v-radio {
  border-color: red;
} */
/* .radio-border[data-v-c437d5c2] {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
} */
</style>
